import { Dispatch } from 'react-redux'
import moment from 'moment'

import { listRegionTags } from 'app-support/regions/state/actions'
import { getBankHoliday } from 'app-support/bankholidays/state/actions'
import { prepareRegionsDataForCombobox } from './utils'

export const preloadDataForEditHoliday = async (dispatch: Dispatch, bankHolidayUUID: string) => {
  const [regionTags, initialBankHolidayData] = await Promise.all([dispatch(listRegionTags()), dispatch(getBankHoliday(bankHolidayUUID))])

  return {
    regionTags: prepareRegionsDataForCombobox(regionTags.Data),
    initialBankHolidayData: initialBankHolidayData.Data
  }
}

export const preloadDataForNewHoliday = async (dispatch: Dispatch) => {
  const { Data } = await dispatch(listRegionTags())
  const regionTags = prepareRegionsDataForCombobox(Data)

  return {
    regionTags,
    initialValues: {
      RegionTagUUID: regionTags.find(f => !!f.UUID)?.UUID || '',
      UUID: '',
      Name: '',
      CreatedAt: '',
      UpdatedAt: '',
      Date: moment(new Date()).format('YYYY-MM-DD')
    }
  }
}
